import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';


export const useEnableTwoFactor = (userId: string) => {
    const { responseHandler } = useResponseHandler();
    const { loading, dismiss, success } = useQueryToast('useEnableTwoFactor');
    return useMutation<any, DefaultError, string>({
      mutationFn: async body => {
        loading(
          i18next.t('service-message.enable.loading')
        );

        const response = await apiClient({
          method: 'POST',
          url: 'Auth/EnableTwoFactor',
          body: {userId: userId},
        });

        return responseHandler(response, {
          groupName: 'useEnableTwoFactor',
          notFoundPath: '/admin/users',
        });
      },
      onSuccess: data => {
        success(
          i18next.t('service-message.enable.success', {
            what: i18next.t('twoFactor.title'),
          })
        );
      },
      onError: dismiss,
    });
  };

  export const useDisableTwoFactor = (userId: string) => {
    const { responseHandler } = useResponseHandler();
    const { loading, dismiss, success } = useQueryToast('useDisableTwoFactor');
    return useMutation<any, DefaultError, string>({
      mutationFn: async body => {
        loading(
          i18next.t('service-message.disable.loading')
        );

        const response = await apiClient({
          method: 'POST',
          url: 'Auth/DisableTwoFactor',
          body: {userId: userId},
        });

        return responseHandler(response, {
          groupName: 'useDisableTwoFactor',
          notFoundPath: '/admin/users',
        });
      },
      onSuccess: data => {
        success(
          i18next.t('service-message.disable.success', {
            what: i18next.t('twoFactor.title'),
          })
        );
      },
      onError: dismiss,
    });
  };